import axios from 'axios';

const fetchClientAPIs = async () => {
  const host = window.location.hostname;
  console.log("host: ", host);
  const cachedData = localStorage.getItem('clientesLucho');
  if (cachedData) return JSON.parse(cachedData);
  try {
    const response = await axios.get(`https://${host}/clientes-lucho`);
    localStorage.setItem('clientesLucho', JSON.stringify(response.data));
    return response.data;
  } catch (error) {
    console.error("Error al obtener clientes:", error);
    return {};
  }
};

const createAxiosInstance = async () => {
  const clientsAPIs = await fetchClientAPIs();
  console.log("clientsAPIs: ", clientsAPIs);
  
  const host = window.location.hostname;
  const API_URL = 'https://'+host; 
  
  return axios.create({
    baseURL: API_URL,
    timeout: 100000,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

const axiosInstancePromise = createAxiosInstance();
export default axiosInstancePromise;
